<mat-list-item *ngIf="treatmentTemplate$ | async as treatmentTemplate">
  <div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="16px"
  >
    <div class="flex min-w-0 flex-1 flex-col">
      <span>{{ treatmentTemplate.name }}</span>
      <span class="text-xs text-slate-500">
        {{ depositSummary$ | async }}
      </span>
    </div>

    <pt-buttons-container>
      <div>
        <button
          mat-icon-button
          ptIntercomTarget="treatment-template.edit-button"
          (click)="editTemplate.emit(treatmentTemplate)"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          ptIntercomTarget="treatment-template.delete-button"
          (click)="deleteTemplate.emit(treatmentTemplate)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </pt-buttons-container>
  </div>
</mat-list-item>
